import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtm from 'vue-gtm';
import { ToolsPlugin } from 'topvue/plugins/tools.js'
import vuetify from './plugins/vuetify';
import browserDetect from "vue-browser-detect-plugin";

Vue.config.productionTip = false

function loaded() {
    Vue.use(ToolsPlugin)
    Vue.use(browserDetect);
    if (process.env.VUE_APP_GTM) {
        Vue.use(VueGtm, {
            id: process.env.VUE_APP_GTM,
            vueRouter: router,
            debug: true,
        });
    }
    window.app = new Vue({
        vuetify,
        router,
        store,
        render: h => h(App),
        data: function() {
            return {
                platformId: window.cordova.platformId,
                fullscreen: false
            }
        },
        mounted() {
            document.addEventListener('fullscreenchange', () => {
                console.log('fullscreenchange', document.fullscreenElement)
                if(document.fullscreenElement !== null) {
                    this.fullscreen = true
                } else {
                    this.fullscreen = false
                }
            })
        },
    }).$mount('#app')
}

window.addEventListener("DOMContentLoaded", loaded, false)
window.cordova = {
    platformId: 'browser',
}
